import React from 'react'
import '../Styles/index.scss'
import CombineShipPage from './CombineShipPage'

function CombineShipPageContainer() {
    return (
        <div className='BatchShipPageContainer'>
            <CombineShipPage/>
        </div>
    )
}

export default CombineShipPageContainer